import React from 'react';

export default class DefaultRouteFallback extends React.PureComponent {
	public render() {
		return <></>;
	}
}
